
import { useCallback, useEffect, useState } from "react";
import { Button, Spin } from "antd";
import { Form, Input } from "@/components";
import { commonApi } from "@/api";
import { useRequest } from "@/hooks";
import { getAccessToken } from "@/utils";
import useForm from "@/components/form/useForm";

import type { FC } from "react";
import type { ModalProps } from "@/components"

import styles from './index.module.scss';

export interface IContent {
  getCertificate?: (certificate: string | null) => void,
  startCountdown?: () => void,
  sendType?: 'VOICE' | 'SMS' | null,
  modalProps?: ModalProps
}

const Content: FC<IContent> = ({ getCertificate, modalProps, startCountdown, sendType="SMS" }) => {

  const [graphicCode, setGraphicCode] = useState<string>('')
  const [token, setToken] = useState<string | null>(null)
  const [success, setSuccess] = useState<boolean>(false)

  const form = useForm();

  const reqGetGraphicVerificationCode = useRequest({ url: commonApi.getGraphicVerificationCode, method: 'get' })
  const reqPostGraphVerify = useRequest({ url: commonApi.postGraphVerify, method: 'post' })

  const gGetGraphicVerificationCode = async () => {
    try {
      if (token) {
        const headers = { Accesstoken: token }
        const { data } = await reqGetGraphicVerificationCode.send({}, { headers })
        setGraphicCode(data)
      }
    }
    catch (error) {
      console.error(error)
    }
  }

  const handleClickCode = useCallback(() => {
    gGetGraphicVerificationCode()
  }, [gGetGraphicVerificationCode])

  const handleChangeDone = useCallback(() => {
    form.validateFields()
      .then(async () => {
        try {
          if (token) {
            const captchaCode = form.getFieldValue('captcha')
            // @ts-ignore
            const { data } = await reqPostGraphVerify.send({ captchaCode }, { headers: { Accesstoken: token } })
            if (data.verifyStatus) {
              getCertificate?.(data.certificate)
              modalProps?.onCancel?.()
              if (sendType === 'SMS') {
                startCountdown?.()
              }
              setSuccess(true)
            }
            else {
              setSuccess(false)
              form.setFieldsError({
                captcha: [{
                  message: 'Invalid CAPTCHA code'
                }]
              })
              gGetGraphicVerificationCode()
            }
          }
        }
        catch (error) {
          console.error(error)
        }
      })
      .catch((error) => {
        console.error(error)
        return
      })
  }, [form, token])

  useEffect(() => {
    gGetGraphicVerificationCode()
  }, [token])

  useEffect(() => {
    setToken(getAccessToken())
  }, [])

  return (
    <Form
      form={form}
    >
      <div className="risk_verification_modal_msg">
        Your requests are too frequent. Please enter below CAPTCHA code for further actions.
      </div>
      <Form.Item
        name="captcha"
        // label='CAPTCHA Code'
        labelProps={{ shrink: true }}
        rules={[
          { required: true },
          { pattern: /^[a-zA-Z0-9]{4}$/, message: 'Invalid CAPTCHA code' },
        ]}
      >
        <Input
          maxLength={4}
          rootClassName="risk_verification_modal_ipt"
          placeholder="CAPTCHA Code"
          prefix={
            <Spin spinning={reqGetGraphicVerificationCode.loading}>
              {
                !reqGetGraphicVerificationCode.loading &&
                <div className="risk_verification_modal_ipt_code" onClick={handleClickCode}>
                  <img src={`data:image/png;base64,${graphicCode}`} />
                </div>
              }
            </Spin>
          }
        />
      </Form.Item>
      <div className="risk_verification_modal_btn">
        <Button onClick={modalProps?.onCancel}>Cancel</Button>
        <Button type="primary" loading={reqPostGraphVerify.loading} onClick={handleChangeDone}>Done</Button>
      </div>
    </Form>
  )
}

export default Content
